import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import CxChooser from '../../cx/CxChooser';
import CxAccordion from '../../cx/CxAccordion';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';
import CxIconButton from '../../cx/CxIconButton';
//import { useNav } from '../../hx/useNav';


const MxSettPsMoveForm = (props) => {
  const [{ trans }] = useTranslation();
  //const [{ navBack }] = useNav();
  const r_snack_required = React.useRef(null);
  const r_snack_op_in_progress = React.useRef(null);
  const r_snack_op_result = React.useRef(null);

  let r_form = React.useRef(null);
  const r_accordion_from = React.useRef(null);
  const r_accordion_to = React.useRef(null);

  const rf_txTypePsGroupFrom = React.useRef(null);
  const rf_txTypePsSubgroupFrom = React.useRef(null);
  const rf_txTypePsGroupTo = React.useRef(null);
  const rf_txTypePsSubgroupTo = React.useRef(null);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);
  
  const doMerge = () => {
    // chequea requeridos
    if (rf_txTypePsGroupFrom.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypePsGroupFrom.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txTypePsSubgroupFrom.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypePsSubgroupFrom.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txTypePsGroupTo.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypePsGroupTo.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txTypePsSubgroupTo.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypePsSubgroupTo.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    
    let itPsGroup_from = rf_txTypePsGroupFrom.current.getKey();
    let itPsSubgroup_from = rf_txTypePsSubgroupFrom.current.getKey();
    let itPsGroup_to = rf_txTypePsGroupTo.current.getKey();
    let itPsSubgroup_to = rf_txTypePsSubgroupTo.current.getKey();

    let record = {};
    record['itPsGroup_from'] = itPsGroup_from;
    record['itPsSubgroup_from'] = itPsSubgroup_from;
    record['itPsGroup_to'] = itPsGroup_to;
    record['itPsSubgroup_to'] = itPsSubgroup_to;
    r_snack_op_in_progress.current.setOpen(true);
    Promise.all([FxFetch.doJsonX(`sett/ps/move/do`, record)]).then((result) => {
      if (result[0]) {
        let nuAffectedRecords = result[0].theValue;
        if (nuAffectedRecords==='0') {
        } else {
          rf_txTypePsGroupFrom.current.clear();
          rf_txTypePsSubgroupFrom.current.clear();
          rf_txTypePsGroupTo.current.clear();
          rf_txTypePsSubgroupTo.current.clear();
        }
        r_snack_op_in_progress.current.setOpen(false);
        r_snack_op_result.current.setValAndOpen(trans('msg.affected_records_x', nuAffectedRecords));
      }
    });
  }

  const groupFromCleared = () => {
    rf_txTypePsSubgroupFrom.current.clear();
    rf_txTypePsSubgroupFrom.current.setFilter(`undefined='${undefined}'`);
  }
  const groupFromSelected = (row) => {
    rf_txTypePsSubgroupFrom.current.clear();
  }
  const subgroupFromOpen = (row) => {
    let itPsGroup = rf_txTypePsGroupFrom.current.getKey();
    if (itPsGroup) {
      rf_txTypePsSubgroupFrom.current.setFilter(`itPsGroup='${itPsGroup}'`);
      return true; // para que abra la ventana de búsqueda.
    } else {
      return false; // para que NO abra la ventana de búsqueda.
    }
  }

  const groupToCleared = () => {
    rf_txTypePsSubgroupTo.current.clear();
    rf_txTypePsSubgroupTo.current.setFilter(`undefined='${undefined}'`);
  }
  const groupToSelected = (row) => {
    rf_txTypePsSubgroupTo.current.clear();
  }
  const subgroupToOpen = (row) => {
    let itPsGroup = rf_txTypePsGroupTo.current.getKey();
    if (itPsGroup) {
      rf_txTypePsSubgroupTo.current.setFilter(`itPsGroup='${itPsGroup}'`);
      return true; // para que abra la ventana de búsqueda.
    } else {
      return false; // para que NO abra la ventana de búsqueda.
    }
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.move_x', 'field.ps')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButton type="issue" classType="ibs_iconbutton_toolbar" onClick={doMerge} tooltip={trans('field.move_x', 'field.ps')} />
          </div>
        }
      >

        <CxAccordion xref={r_accordion_from} title={trans('field.from')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} defaultExpanded >
          <CxChooser xref={rf_txTypePsGroupFrom}
            label={`${trans('field.group')}`}
            dbfield='t_ps_group.txTypePsGroup' dbfieldkey='n_ps.itPsGroup'
            table="t_ps_group"
            col_id="itPsGroup"
            col_tx="txTypePsGroup"
            filter={`t_ps_group.boActive='${'1'}'`}
            onClear={groupFromCleared}
            onSelection={groupFromSelected}
            required
          />

          <CxChooser xref={rf_txTypePsSubgroupFrom}
            label={`${trans('field.subgroup')}`}
            dbfield='t_ps_subgroup.txTypePsSubgroup' dbfieldkey='n_ps.itPsSubgroup'
            canOpenDialog={subgroupFromOpen}
            table="t_ps_subgroup"
            col_id="itPsSubgroup"
            col_tx="txTypePsSubgroup"
            filter={`t_ps_subgroup.boActive='${'1'}'`}
            required
          />
        </CxAccordion>

        <CxAccordion xref={r_accordion_to} title={trans('field.to')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} defaultExpanded >
          <CxChooser xref={rf_txTypePsGroupTo}
            label={`${trans('field.group')}`}
            dbfield='t_ps_group.txTypePsGroup' dbfieldkey='n_ps.itPsGroup'
            table="t_ps_group"
            col_id="itPsGroup"
            col_tx="txTypePsGroup"
            filter={`t_ps_group.boActive='${'1'}'`}
            onClear={groupToCleared}
            onSelection={groupToSelected}
            required
          />

          <CxChooser xref={rf_txTypePsSubgroupTo}
            label={`${trans('field.subgroup')}`}
            dbfield='t_ps_subgroup.txTypePsSubgroup' dbfieldkey='n_ps.itPsSubgroup'
            canOpenDialog={subgroupToOpen}
            table="t_ps_subgroup"
            col_id="itPsSubgroup"
            col_tx="txTypePsSubgroup"
            filter={`t_ps_subgroup.boActive='${'1'}'`}
            required
          />
        </CxAccordion>

      </GxForm>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_op_in_progress} severity="info" value={trans('msg.operation_in_progress')} autoHideDuration={10000} />
      <CxSnackbar xref={r_snack_op_result} severity="info" />
    </div>
  );

}

export default MxSettPsMoveForm;
